import React from 'react'

const SvgQuoteRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 12c-1.644 0-3-1.334-3-3.023S6.399 6 8 6s3 1.001 3 3.971c0 4.495-1.333 7.171-4 8.029H5c3.976-1.985 3.253-6 3-6zm8 0c-1.644 0-3-1.334-3-3.023S14.399 6 16 6s3 1.001 3 3.971c0 4.495-1.333 7.171-4 8.029h-2c3.976-1.985 3.253-6 3-6z'
    />
  </svg>
)

export default SvgQuoteRight
